import { createSlice } from "@reduxjs/toolkit";

import {
  createTeam,
  getAllTeams,
  getTeam,
  updateTeam,
  deleteTeam,
  assignUserToTeam,
  updateUserTeamRole,
} from "../thunks/Team";

const teamSlice = createSlice({
  name: "team",
  initialState: {
    teams: [],
    selectedTeam: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedTeam: (state) => {
      state.selectedTeam = null;
    },
  },
  extraReducers(builder) {
    // Create Team
    builder
      .addCase(createTeam.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createTeam.fulfilled, (state, action) => {
        state.isLoading = false;
        state.teams.push(action.payload.data.team);
      })
      .addCase(createTeam.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Get All Teams
    builder
      .addCase(getAllTeams.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllTeams.fulfilled, (state, action) => {
        state.isLoading = false;
        state.teams = action.payload.data.teams;
      })
      .addCase(getAllTeams.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Get Team
    builder
      .addCase(getTeam.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getTeam.fulfilled, (state, action) => {
        state.isLoading = false;
        state.selectedTeam = action.payload.data.team;
      })
      .addCase(getTeam.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Update Team
    builder
      .addCase(updateTeam.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateTeam.fulfilled, (state, action) => {
        state.isLoading = false;
        const updatedTeam = action.payload.data.team;
        const index = state.teams.findIndex((t) => t._id === updatedTeam._id);
        if (index !== -1) {
          state.teams[index] = updatedTeam;
        }
        if (state.selectedTeam && state.selectedTeam._id === updatedTeam._id) {
          state.selectedTeam = updatedTeam;
        }
      })
      .addCase(updateTeam.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Delete Team
    builder
      .addCase(deleteTeam.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteTeam.fulfilled, (state, action) => {
        state.isLoading = false;
        state.teams = state.teams.filter((t) => t._id !== action.meta.arg);
        if (state.selectedTeam && state.selectedTeam._id === action.meta.arg) {
          state.selectedTeam = null;
        }
      })
      .addCase(deleteTeam.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Assign User to Team
    builder
      .addCase(assignUserToTeam.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(assignUserToTeam.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(assignUserToTeam.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Update User Team Role
    builder
      .addCase(updateUserTeamRole.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateUserTeamRole.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateUserTeamRole.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearSelectedTeam } = teamSlice.actions;
export const teamReducer = teamSlice.reducer;





